import { render, staticRenderFns } from "./DrogasVacunasSintomas.vue?vue&type=template&id=590d69c8"
import script from "./DrogasVacunasSintomas.vue?vue&type=script&lang=js"
export * from "./DrogasVacunasSintomas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports